import React from 'react';
import { MapContainer, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import './MapStyleTest.css';

// Testseite zum Vergleich verschiedener Kartenstile (Farbgebung der TileLayer).
// Nicht in der Navigation verlinkt - nur ueber die direkte URL /map-test erreichbar.
// Zentrum: Rosa-Luxemburg-Platz, gleiche Koordinaten wie die Hauptkarte.

const CENTER = [52.526716, 13.411683];
const ZOOM = 16;

const STYLES = [
  {
    name: 'OpenStreetMap (aktuell live)',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; OpenStreetMap contributors',
  },
  {
    // Ersatz fuer CartoDB Positron: CARTO verlangt inzwischen einen kostenlosen
    // API-Key (ohne Key nur noch "API KEY REQUIRED"-Wasserzeichen). Esri Light Gray
    // ist optisch sehr aehnlich (hell, reduziert) und braucht keinen Key.
    name: 'Esri World Light Gray (hell, reduziert)',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Tiles &copy; Esri',
  },
  {
    // Ersatz fuer CartoDB Dark Matter, gleicher Grund wie oben.
    name: 'Esri World Dark Gray (dunkel)',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Tiles &copy; Esri',
  },
  {
    // Ersatz fuer Stamen Toner: Stamen-Hosting wurde 2023 abgeschaltet (nur noch
    // ueber Stadia Maps mit kostenlosem Account verfuegbar). OpenTopoMap ist
    // ebenfalls kraeftig andersfarbig (gruen/braun, topografisch) und braucht
    // keinen Key.
    name: 'OpenTopoMap (topografisch, gruen/braun)',
    url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
    attribution: 'Map data: &copy; OpenStreetMap contributors, SRTM | Map style: &copy; OpenTopoMap (CC-BY-SA)',
  },
  {
    // Ersatz fuer Stamen Watercolor, gleicher Grund wie oben. CyclOSM hat einen
    // sehr eigenen, kraeftigen Farblook (Rad-Infrastruktur im Fokus).
    name: 'CyclOSM (kraeftige Farben, Rad-Fokus)',
    url: 'https://{s}.tile-cyclosm.openstreetmap.fr/cyclosm/{z}/{x}/{y}.png',
    attribution: '&copy; OpenStreetMap contributors, CyclOSM',
  },
];

const MapStyleTest = () => {
  return (
    <div className="map-style-test-page">
      <h1>Kartenstile im Vergleich</h1>
      <p className="map-style-test-lede">
        Testseite, nicht verlinkt. Zeigt verschiedene TileLayer-Anbieter auf denselben
        Kartenausschnitt (Rosa-Luxemburg-Platz), um die Farbgebung zu vergleichen.
      </p>
      <div className="map-style-test-grid">
        {STYLES.map((style) => (
          <div className="map-style-test-tile" key={style.name}>
            <div className="map-style-test-label">{style.name}</div>
            <MapContainer
              center={CENTER}
              zoom={ZOOM}
              style={{ height: '320px', width: '100%' }}
              scrollWheelZoom={false}
            >
              <TileLayer url={style.url} attribution={style.attribution} />
            </MapContainer>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MapStyleTest;
